<template>
  <div class="pfslide">
    <div class="pfslide__title pfslide__title_smspace" v-html="title"></div>
    <div class="pfslide__smtitle pfslide__smtitle_smspace">Проверьте Ваши данные</div>
    <div style="width: 816px; max-width: 100%;">
      <Table :noshadow="true" :defwidth="320" 
        :lines="[
          ['ФИО',client?.fullname],
          ['Пол',client?.sex],
          ['Объект страхования',client?.object?.type],
          ['Адрес',(client?.object?.address?.text + (noflat?'':`, кв. ${client?.object?.address?.flat}`))],
          ['Серия и номер паспорта',client?.passport?.series],
          ['Дата выдачи',client?.passport?.date],
          ['Дата рождения',client?.birthdate],
          ['Место рождения',client?.pob],
          ['Номер телефона',client?.tel],
          ['E-mail',client?.email],
          ['Тариф',client?.program],
        ]"
      />
      <div class="pfslide5__linkline" style="margin: 17px 0 16px">
        <a :href="exampleLink" target="_blank" class="pfslide__exlink">
          <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5723 4.28516C11.5723 2.90444 12.6916 1.78516 14.0723 1.78516H28.8252L38.7151 12.4358V35.7137C38.7151 37.0944 37.5958 38.2137 36.2151 38.2137H14.0723C12.6916 38.2137 11.5723 37.0944 11.5723 35.7137V28.5709C11.5723 27.9791 12.052 27.4994 12.6437 27.4994C13.2354 27.4994 13.7151 27.9791 13.7151 28.5709V35.7137C13.7151 35.911 13.875 36.0709 14.0723 36.0709H36.2151C36.4124 36.0709 36.5723 35.911 36.5723 35.7137V13.928H27.2866V3.92801H14.0723C13.875 3.92801 13.7151 4.08791 13.7151 4.28516V14.9994C13.7151 15.5912 13.2354 16.0709 12.6437 16.0709C12.052 16.0709 11.5723 15.5912 11.5723 14.9994V4.28516ZM29.4294 5.58502L35.1867 11.7852H29.4294V5.58502Z" fill="#250708"/> <path d="M7.28516 19.2861H9.14909C10.5706 19.2861 11.2813 19.8457 11.2813 20.9647C11.2813 22.0838 10.5706 22.6433 9.14909 22.6433H8.34421V24.2861H7.28516V19.2861ZM9.19851 21.7004C9.86689 21.7004 10.2011 21.4552 10.2011 20.9647C10.2011 20.4742 9.86689 20.229 9.19851 20.229H8.34421V21.7004H9.19851Z" fill="#E9041E"/> <path d="M12.0581 19.2861H13.9079C14.7551 19.2861 15.3976 19.5147 15.8354 19.9718C16.2778 20.4242 16.499 21.029 16.499 21.7861C16.499 22.5433 16.2778 23.1504 15.8354 23.6076C15.3976 24.0599 14.7551 24.2861 13.9079 24.2861H12.0581V19.2861ZM15.0305 22.9504C15.2894 22.6885 15.4188 22.3004 15.4188 21.7861C15.4188 21.2718 15.2894 20.8838 15.0305 20.6218C14.7763 20.3599 14.4021 20.229 13.9079 20.229H13.1171V23.3433H13.9079C14.4021 23.3433 14.7763 23.2123 15.0305 22.9504Z" fill="#E9041E"/> <path d="M17.3688 19.2861H20.8566V20.2504H18.4278V21.4147H20.6518V22.379H18.4278V24.2861H17.3688V19.2861Z" fill="#E9041E"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M2.28516 18.5711C2.28516 16.4015 4.04404 14.6426 6.21373 14.6426H21.928C24.0977 14.6426 25.8566 16.4015 25.8566 18.5711V24.9997C25.8566 27.1694 24.0977 28.9283 21.928 28.9283H6.21373C4.04404 28.9283 2.28516 27.1694 2.28516 24.9997V18.5711ZM6.21373 16.7854C5.2275 16.7854 4.42801 17.5849 4.42801 18.5711V24.9997C4.42801 25.9859 5.2275 26.7854 6.21373 26.7854H21.928C22.9142 26.7854 23.7137 25.9859 23.7137 24.9997V18.5711C23.7137 17.5849 22.9142 16.7854 21.928 16.7854H6.21373Z" fill="#E9041E"/> </svg>
          <span>Образец страхового полиса и Ключевой информационный документ</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import slide from '../../mixins/slide.vue'
  import Table from '../Table.vue'
  export default {
    name: "slide6",
    mixins: [slide],
    computed: {
      ...mapState(["exampleLink", "client"]),
      ...mapGetters(["noflat"])
    },
    components: { Table }
}
</script>

<style lang="sass">
.pfslide__exlink
  cursor: pointer
  display: flex
  justify-content: center
  align-items: center
  font-size: 16px
  line-height: 26px
  color: colors.$brownfont
  &_alone
    margin: 24px auto
    margin-top: 32px
    margin-bottom: 98px
  span
    font-size: 14px
    line-height: 1.12
    color: colors.$newred
  svg
    transform: translateY(-1px)
    margin-right: 7px
</style>